import { combineReducers } from 'redux';
import { CounterpartyReducer } from './Counterparties/services/reducer';
import { PackingReducer } from './Packaging/services/reducer';
import { ProductReducer } from './Products/services/reducer';
import { WithdrawalReducer } from './Withdrawal/services/reducer';

export const handbookModuleReducer = combineReducers({
  CounterpartyReducer,
  PackingReducer,
  ProductReducer,
  WithdrawalReducer,
});

export type HandbookModuleReducer = ReturnType<typeof handbookModuleReducer>;
